/**
 * Metrics Event Types
 * Standardized event payload structure for metrics recording
 */

export interface MetricsEventProperties {
    category?: string;
    label?: string;
    value?: number;
    [key: string]: any;
}

export interface MetricsEvent {
    eventName: string;
    properties: MetricsEventProperties;
}

/**
 * Standard event names for signup funnel
 */
export const MetricsEventNames = {
    // Signup funnel events
    SIGNUP_STARTED: 'signup_started',
    SIGNUP_STEP_VIEWED: 'signup_step_viewed',
    SIGNUP_STEP_COMPLETED: 'signup_step_completed',
    SIGNUP_COMPLETED: 'signup_completed',
    SIGNUP_FAILED: 'signup_failed',
    
    // Product selection
    PRODUCT_SELECTED: 'product_selected',
    
    // Payment events
    PAYMENT_METHOD_CREATED: 'payment_method_created',
    PAYMENT_METHOD_FAILED: 'payment_method_failed',
    
    // Conversion events
    CONVERSION_COMPLETED: 'conversion_completed',
    
    // Error events
    ERROR_OCCURRED: 'error_occurred',
    
    // User action events
    BUTTON_CLICKED: 'button_clicked',
    FORM_FIELD_COMPLETED: 'form_field_completed',
} as const;

export type MetricsEventName = typeof MetricsEventNames[keyof typeof MetricsEventNames];

